import { useEffect, useState } from 'react';

import {
  ConsentStatus,
  observeIubendaConsent,
  readIubendaConsent,
} from './iubendaConsent';

export function useIubendaConsent(): ConsentStatus {
  const [consentStatus, setConsentStatus] =
    useState<ConsentStatus>(readIubendaConsent);

  useEffect(() => {
    if (consentStatus !== 'pending') return;

    return observeIubendaConsent(setConsentStatus);
  }, []);

  return consentStatus;
}
